import { render } from "./ViewJamakkol.vue?vue&type=template&id=5932fd80&scoped=true"
import script from "./ViewJamakkol.vue?vue&type=script&lang=js"
export * from "./ViewJamakkol.vue?vue&type=script&lang=js"

import "./ViewJamakkol.vue?vue&type=style&index=0&id=5932fd80&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2623155984/src/jamakkol-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5932fd80"]])

export default __exports__